// Sprint 3 Story 5: Dashboard-Layout-Helper.
//
// Default-Layout für neue User (kein eigenes Layout abgespeichert): vier
// Pflicht-Widgets in 3-Spalten-Anordnung.

import type { DashboardWidget, DashboardWidgetSize } from "@juuplan/shared";

export const ALL_WIDGET_IDS = [
  "my-tasks",
  "my-projects",
  "my-lists",
  "overdue",
  "this-week",
  // Phase 2 (kommt mit Story 5b):
  "activity",
  "mentions",
  "today",
  "project-stats",
  "whats-new",
  "progress",
] as const;
export type WidgetId = (typeof ALL_WIDGET_IDS)[number];

export const WIDGET_LABELS: Record<WidgetId, string> = {
  "my-tasks": "Meine Aufgaben",
  "my-projects": "Meine Projekte",
  "my-lists": "Meine Aufgabenlisten",
  overdue: "Überfällig",
  "this-week": "Diese Woche fällig",
  activity: "Letzte Aktivität",
  mentions: "Erwähnungen",
  today: "Heute fällig",
  "project-stats": "Projekt-Statistik",
  "whats-new": "Was ist neu",
  progress: "Fortschritt",
};

export const SIZE_LABELS: Record<DashboardWidgetSize, string> = {
  small: "Klein",
  half: "Halb",
  wide: "Breit",
  full: "Voll",
};

export const SIZE_SPANS: Record<DashboardWidgetSize, number> = {
  small: 2, // 2 / 6
  half: 3, // 3 / 6
  wide: 4, // 4 / 6
  full: 6, // 6 / 6
};

export const DEFAULT_LAYOUT: DashboardWidget[] = [
  { id: "my-tasks", size: "small", order: 1 },
  { id: "this-week", size: "small", order: 2 },
  { id: "overdue", size: "small", order: 3 },
  { id: "my-projects", size: "full", order: 4 },
  { id: "my-lists", size: "full", order: 5 },
  { id: "whats-new", size: "half", order: 6 },
];

/** Sortierter, gefilterter View des User-Layouts. Bei leerer User-Auswahl
 *  fällt es auf das Default-Set zurück. */
export function effectiveLayout(saved: DashboardWidget[]): DashboardWidget[] {
  const base = saved.length > 0 ? saved : DEFAULT_LAYOUT;
  return [...base].sort((a, b) => a.order - b.order);
}
